<template>
  <section>
    <b-field grouped group-multiline>
      <b-field>
        <p class="control">
          <span class="button is-static">
            {{ $t('attributes.activation_status') }}
          </span>
        </p>
        <b-select v-model="filterStatus" @input="onFilterStatus">
          <option value="">{{ $t('attributes.all') }}</option>
          <option value="true">{{ $t('attributes.shelve_on') }}</option>
          <option value="false">{{ $t('attributes.shelve_off') }}</option>
        </b-select>
      </b-field>
      <b-field class="ml-auto">
        <b-button type="is-info" @click="onCreate()">
          {{ $t('attributes.add') + $t('attributes.area') }}
        </b-button>
      </b-field>
    </b-field>

    <b-table
      :data="items"
      :selected="selectedItem"
      :loading="isLoading"
      :hoverable="true"
      :narrowed="true"
      :mobile-cards="true"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      @select="onSelect"
      @sort="onSort"
    >
      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        width="75"
        sortable
        numeric
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="status"
        :label="$t('attributes.activation_status')"
        width="75"
        sortable
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.status ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ shelveStatus(props.row.status) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        field="code"
        :label="$t('attributes.area_code')"
        width="110"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.code }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        v-slot="props"
      >
        <p v-html="props.row.name"></p>
      </b-table-column>

      <b-table-column
        field="english_name"
        :label="$t('attributes.english_name')"
        sortable
        v-slot="props"
      >
        <p v-html="props.row.english_name"></p>
      </b-table-column>

      <b-table-column
        field="menu_name"
        :label="$t('attributes.display_name')"
        sortable
        v-slot="props"
      >
        <p v-html="props.row.menu_name"></p>
      </b-table-column>

      <b-table-column
        field="promote_num"
        :label="$t('attributes.is_promote_count')"
        width="100"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.promote_num }}
      </b-table-column>

      <b-table-column
        field="is_promote"
        :label="$t('attributes.is_promote')"
        width="150"
        sortable
        centered
        v-slot="props"
      >
        {{ displayStatus(props.row.is_promote) }}
      </b-table-column>

      <b-table-column
        field="home_top_show"
        :label="$t('attributes.home_top_show')"
        width="110"
        sortable
        centered
        v-slot="props"
      >
        {{ displayStatus(props.row.home_top_show) }}
      </b-table-column>

      <b-table-column
        field="home_left_show"
        :label="$t('attributes.area_popup')"
        width="110"
        sortable
        centered
        v-slot="props"
      >
        {{ displayStatus(props.row.home_left_show) }}
      </b-table-column>

      <template #empty>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>
    <b-modal
      :active.sync="isCreateModalActive"
      :can-cancel="['x']"
      has-modal-card
    >
      <area-form :isSending="createSending" @onSend="create" />
    </b-modal>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import AreaForm from '@/components/areas/AreaForm.vue'

export default {
  name: 'AreaList',
  components: { AreaForm },

  props: {
    query: {
      type: Object,
      required: true
    },
    selected: {
      type: Object
    },
    loadingItem: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loadingItems: false,
      items: [],
      selectedItem: null,

      filterStatus:
        this.query.status === undefined ? 'true' : this.query.status,
      sortField: this.query.sort || 'sort',
      sortOrder: this.query.order || 'asc',
      defaultSortOrder: 'asc',

      isCreateModalActive: false,
      createSending: false
    }
  },
  watch: {
    query(newQuery) {
      this.getQuery(newQuery)
      this.loadItems()
    },
    selected(item) {
      if (item) {
        this.items = this.items.map(x => {
          if (x.code === item.code) {
            return item
          } else {
            return x
          }
        })
      }
      this.selectedItem = item
    }
  },
  computed: {
    isLoading() {
      return this.loadingItems || this.loadingItem
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      try {
        const api = `${AREA_API}/search`
        const params = {
          active: this.filterStatus && this.filterStatus === 'true'
        }

        this.loadingItems = true
        const code = this.selectedItem && this.selectedItem.code

        const res = await this.axios.get(api, { params })
        const areas = res.data.data
        this.items = areas.sort(a => a.sort)

        if (code) {
          const item = this.items.find(x => x.code === code)
          this.onSelect(item)
        }
      } catch (e) {
        this.items = []
        this.onSelect(null)

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingItems = false
      }
    },
    onFilterStatus() {
      this.onSelect(null)
      this.updateQuery()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order

      this.updateQuery()
    },
    onSelect(item) {
      this.selectedItem = item
      this.$emit('select', this.selectedItem)
      this.$emit('update:selected', this.selectedItem)
    },
    getQuery(query) {
      this.filterStatus = query.status || ''
      this.sortField = query.sort || 'sort'
      this.sortOrder = query.order || 'asc'
    },
    updateQuery() {
      const query = {
        status: this.filterStatus,
        sort: this.sortField,
        order: this.sortOrder
      }

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
    },
    onCreate() {
      this.isCreateModalActive = true
      this.createSending = false
    },
    async create(item) {
      this.createSending = true
      try {
        const res = await this.axios.post(AREA_API, item)
        const data = res.data.message
        notifyService.success(data)

        await this.loadItems()
      } catch (e) {
        notifyService.fetch_error('area', e)
      } finally {
        this.createSending = false
        this.isCreateModalActive = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.b-table {
  margin-top: 0.75rem;

  td {
    vertical-align: middle;
  }
}
</style>
